export type ThemeType = {
  primary: string;
  secondary: string;
  background: string;
  button: {
    primary: string;
    secondary: string;
    disabled: string;
    warning: string;
    border: string;
  };
};

export const theme: ThemeType = {
  primary: '#4B6EFA',
  secondary: '#FFFFFF',
  background: '#FEF',
  button: {
    primary: '#4B6EFA',
    secondary: '#FFFFFF',
    disabled: 'rgba(0, 0, 0, 0.3)',
    warning: '#FD6157',
    border: '#A5B7FD',
  },
};
